'use client';
import Image from 'next/image';

export default function MediaPartnersLogoSection() {

 const mediaPartners = [
  {
    src: "/images/theholycoins-ring-white-bg.webp",
    alt: "TheHolyCoins",
    href: "https://theholycoins.com/",
  },
  {
    src: "/images/coinlyx.webp",
    alt: "Coinlyx",
    href: "https://coinlyx.com/",
  },
  {
    src: "/images/bitcoin-world.webp",
    alt: "Bitcoin World",
    href: "https://bitcoinworld.co.in/",
  },
  {
    src: "/images/coinaute.webp",
    alt: "Coinaute",
    href: "https://coinaute.com/",
  },
  {
    src: "/images/coinedition.webp",
    alt: "CoinEdition",
    href: "https://coinedition.com/",
  },
  {
    src: "/images/crypto-news.svg",
    alt: "Crypto News",
    href: "https://crypto.news/",
  },
  {
    src: "/images/the-cryptonomist-logo.webp",
    alt: "The Cryptonomist",
    href: "https://en.cryptonomist.ch/",
  },
  {
    src: "/images/financial-logo.svg",
    alt: "Financial Services Review",
    href: "https://www.financialservicesreview.com/",
  },
  {
    src: "/images/coin-gabbar-logo-dark.svg",
    alt: "CoinGabbar",
    href: "https://www.coingabbar.com/",
  },
  {
    src: "/images/unite.svg",
    alt: "Unite AI",
    href: "https://www.unite.ai/",
  },
  {
    src: "/images/spaziocrypto.webp",
    alt: "SpazioCrypto",
    href: "https://www.spaziocrypto.com/",
  },
  {
    src: "/images/cryptopulsenews.svg",
    alt: "Crypto Pulse News",
    href: "https://cryptopulse.news/",
  },
  {
    src: "/images/3versetv.webp",
    alt: "3VerseTV",
    href: "https://www.3versetv.com/",
  },
  {
    src: "/images/cryptovate.webp",
    alt: "Cryptovate",
    href: "https://cryptovate.io/",
  },
  {
    src: "/images/cryptobrowser.svg",
    alt: "Crypto Browser",
    href: "https://cryptobrowser.site/",
  },
  {
    src: "/images/coinfea.webp",
    alt: "Coinfea",
    href: "https://coinfea.com/",
  },
  {
    src: "/images/blockchain-logo.webp",
    alt: "Blockchain Reporter",
    href: "https://blockchainreporter.net/",
  },
  {
    src: "/images/bftimes.webp",
    alt: "Blockchain Finance Times",
    href: "https://www.bftimes.com/",
  },
  {
    src: "/images/coinstori.webp",
    alt: "Coinstori",
    href: "https://coinstori.com/",
  },
  {
    src: "/images/bitcoininsider.webp",
    alt: "Bitcoin Insider",
    href: "https://www.bitcoininsider.org/",
  },
  {
    src: "/images/blockweeks.webp",
    alt: "BlockWeeks",
    href: "https://blockweeks.com/",
  },
  {
    src: "/images/cryptopress-logo.webp",
    alt: "Crypto Press",
    href: "https://cryptopress.news/",
  },
  {
    src: "/images/alhudacibe-logo.webp",
    alt: "AlHuda CIBE",
    href: "https://www.alhudacibe.com/",
  },
  {
    src: "/images/alhudatoday.webp",
    alt: "AlHuda Today",
    href: "https://www.alhudatoday.com/",
  },
  {
    src: "/images/gazetinternational-logo.webp",
    alt: "Gazet International",
    href: "https://gazetinternational.com/",
  },
  {
    src: "/images/eemirates-logo.webp",
    alt: "E Emirates",
    href: "https://eemirates.net/",
  },
  {
    src: "/images/wikiexpo.webp",
    alt: "WikiExpo",
    href: "https://wikiexpo.com/",
  },
  {
    src: "/images/cryptopolitan.webp",
    alt: "cryptopolitan",
    href:"https://www.cryptopolitan.com/"
  },
  {
    src: "/images/block24seven.webp",
    alt: "block24seven",
    href:"https://block24seven.com/"
  },
  {
    src: "/images/ether-pr.webp",
    alt: "etherpr",
    href:"https://etherpr.com/"
  },
  {
    src: "/images/coinrab.webp",
    alt: "coinrab",
    href:"https://coinrab.com/"
  },
  {
    src: "/images/coinraftar-logo.webp",
    alt: "coinrab",
    href:"https://coinraftar.com/"
  },
  {
    src: "/images/irevs.webp",
    alt: "irevs",
    href:"https://www.irevs.co/"
  },
  {
    src: "/images/amb-crypto.svg",
    alt: "ambcrypto",
    href:"https://ambcrypto.com/"
  },
  {
    src: "/images/zexprwire-logo.webp",
    alt: "irevs",
    href:"https://zexprwire.com/"
  },

];
  return (
    <section data-component-id="src/app/MediaPartnersLogoSection.tsx:185:4" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="185" data-component-end-line="219" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22mediapartners%22%2C%22className%22%3A%22w-full%20bg-white%20pb-20%22%7D" id="mediapartners" className="w-full bg-white pb-20">
      
      <div data-component-id="src/app/MediaPartnersLogoSection.tsx:187:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="187" data-component-end-line="191" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20px-4%22%7D" className="max-w-[1200px] mx-auto px-4">
        <h2 data-component-id="src/app/MediaPartnersLogoSection.tsx:188:8" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="188" data-component-end-line="190" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20text-center%20sm%3Atext-%5B32px%5D%20md%3Atext-%5B36px%5D%20lg%3Atext-%5B42px%5D%20font-semibold%20py-2%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-[28px] text-center sm:text-[32px] md:text-[36px] lg:text-[42px] font-semibold py-2">
          Media Partners
        </h2>
      </div>

      <div data-component-id="src/app/MediaPartnersLogoSection.tsx:193:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="193" data-component-end-line="218" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20w-full%22%7D" className="flex justify-center items-center w-full">
        <div data-component-id="src/app/MediaPartnersLogoSection.tsx:194:8" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="194" data-component-end-line="217" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20justify-center%20items-center%20w-full%20sm%3Aw-%5B85%25%5D%20md%3Aw-%5B75%25%5D%20lg%3Aw-%5B74%25%5D%20gap-6%22%7D" className="flex flex-wrap justify-center items-center w-full sm:w-[85%] md:w-[75%] lg:w-[74%] gap-6">
          
          {mediaPartners.map((partner, index) => (
            <a data-component-id="src/app/MediaPartnersLogoSection.tsx:197:12" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="197" data-component-end-line="214" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20w-%5B160px%5D%20h-%5B80px%5D%20bg-white%20border-2%20border-%5B%23E8ACD4%5D%20rounded-%5B10px%5D%20overflow-hidden%22%7D"
              key={index}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center justify-center w-[160px] h-[80px] bg-white border-2 border-[#E8ACD4] rounded-[10px] overflow-hidden"
            >
              <Image data-component-id="src/app/MediaPartnersLogoSection.tsx:204:14" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="204" data-component-end-line="213" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%7D"
                src={partner.src}
                alt={partner.alt}
                width={160}
                height={80}
                unoptimized
                className={`object-contain w-full h-full transition-all duration-300 ${
                  partner.large ? 'scale-150' : 'p-2'
                }`}
              />
            </a>
          ))}

        </div>
      </div>
    </section>
  );
}




